<template>
  <section>
    <project-info :isShowCloseIcon="'false'"></project-info>
  </section>
</template>
<script>
  import {
    mapState
  } from "vuex";


  import projectInfo from '../user/projectInfo'
  export default {
    components: {
      projectInfo,
    },
    computed: {
      ...mapState({
        // organization: state => state.main.organization,
        // userData: state => state.main.userData,
        projectTable: state => state.main.projectTable,
      })
    },
    mounted () {
      let applyId = this.$route.params.applyId
      let tableType = this.$route.params.tableType

      let _projectTable = this.projectTable
      _projectTable.status = true
      _projectTable.applyId = applyId
      _projectTable.tableType = tableType
      this.$store.commit('set_projectTable', _projectTable)
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/m/approvalInfo.vue